import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';
import translate from '@/lib/intl/translate';
import { TaskSortBy as SortBy } from '../tasksConfig';

function TaskSortSelect({ className, filters, onFilterUpdate }) {
  const sortSelectItems = [
    { value: SortBy.DUE_DATE, label: translate('TASKS_DUE_DATE') },
    {
      value: SortBy.TASK_TITLE,
      label: translate('TITLE_LABEL'),
    },
    { value: SortBy.CREATED, label: translate('TASKS_CREATION_TIME') },
  ];
  return (
    <FormControl className={className}>
      <InputLabel className="whitespace-nowrap" id="task-sort-select-label">
        {translate('FORMS_SORT_BY')}
      </InputLabel>
      <Select
        labelId="task-sort-select-label"
        id="task-sort-select"
        value={filters?.sortBy || 'due_date'}
        className="w-full"
        name="sortBy"
        label={translate('FORMS_SORT_BY')}
        onChange={onFilterUpdate}
        displayEmpty
      >
        {sortSelectItems.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
TaskSortSelect.propTypes = {
  className: PropTypes.string,
  filters: PropTypes.shape({
    userId: PropTypes.string,
    sortBy: PropTypes.string,
    sortOrder: PropTypes.string,
    isCompleted: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  }).isRequired,
  onFilterUpdate: PropTypes.func.isRequired,
};

TaskSortSelect.defaultProps = {
  className: '',
};
export default TaskSortSelect;
